module.exports = __webpack_public_path__ + "static/2_3_game-tree-4_LT-76a203f65e4d98e5a03466567395a930.svg";